import { useFormContext, useWatch } from 'react-hook-form';
import { FormFields } from '../AccountForm.meta';
import { useAccountFormContext } from '../context/useAccountFormContext';
import { AccountTaxStatusDTO } from '../../../../../api/useAccountsQuery';

export const useAccountTaxStatusLabel = (taxStatus: AccountTaxStatusDTO | null) => {
  const { control } = useFormContext<FormFields>();

  const {
    options: { AccountTypeOptions: accountTypeOptions },
  } = useAccountFormContext();

  const accountType = useWatch({ name: 'bankAccount.AccountType', control });

  if (accountType === null || taxStatus === null) {
    return { taxStatusLabel: null };
  }

  const accountOptions = accountTypeOptions.find(option => option.AccountType === accountType);

  if (!accountOptions) {
    return { taxStatusLabel: null };
  }

  const { AssetAllocationTaxStatuses: assetAllocationTaxStatusesOptions } = accountOptions;

  const taxStatusOption = assetAllocationTaxStatusesOptions.find(
    option => option.Value === taxStatus,
  );

  if (!taxStatusOption) {
    return { taxStatusLabel: null };
  }

  return {
    taxStatusLabel: taxStatusOption.Label,
  };
};
